import { render, staticRenderFns } from "./AssignAccreditationTable.component.vue?vue&type=template&id=89b89e28&scoped=true"
import script from "./AssignAccreditationTable.component.vue?vue&type=script&lang=js"
export * from "./AssignAccreditationTable.component.vue?vue&type=script&lang=js"
import style0 from "./AssignAccreditationTable.component.vue?vue&type=style&index=0&id=89b89e28&prod&lang=scss"
import style1 from "./AssignAccreditationTable.component.vue?vue&type=style&index=1&id=89b89e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b89e28",
  null
  
)

export default component.exports